import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment"; // Adjust path as per your project
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType"; // Adjust path as per your project
import ApiRequest from "../ApiRequest"; // Adjust path as per your project

export type VerifyEmailResponse = ResponseType<null>; // Assuming the response data is null on success

function useResendVerifyEmailOtpMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<VerifyEmailResponse>["response"], // Success type (AxiosResponse<ResponseType<null>>)
    AxiosResponseAndError<VerifyEmailResponse>["error"], // Error type (AxiosError<ErrorResponseType>)
    null // Variables type (null because it's a POST request without body)
  >({
    mutationFn: () =>
      ApiRequest.post<VerifyEmailResponse>(requestURLs.resendVerifyEmailOtp),
  });

  return mutation;
}

export default useResendVerifyEmailOtpMutation;